import {creates, hoistCmp} from '@xh/hoist/core';
import {RealEstateTabModel} from './RealEstateTabModel';
import {tabContainer} from '@xh/hoist/cmp/tab';
import {tabSwitcher} from '@xh/hoist/desktop/cmp/tab';
import {hframe} from '@xh/hoist/cmp/layout';
import './RealEstateTab.scss';

export const realEstateTab = hoistCmp.factory({
    model: creates(RealEstateTabModel),
    className: 'realestate-tab',
    render({model, className}) {
        return hframe({
            className,
            items: [tabSwitcher({orientation: 'left'}), tabContainer({switcher: false})]
        });
    }
});
